var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 276,
    viewBox: "0 0 184 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8334 275.5C142.55 275.5 183.667 234.383 183.667 183.667L-4.01417e-06 183.667C-1.79729e-06 234.383 41.1173 275.5 91.8334 275.5Z",
    fill: "#0999B9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.3696,
    cy: 91.8334,
    rx: 91.3696,
    ry: 91.8334,
    fill: "#DEAD7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupported);
export default __webpack_public_path__ + "static/media/Supported.a7b5abd04a2fccb46add1ea62b82242b.svg";
export { ForwardRef as ReactComponent };